import { useEffect, useState } from 'react';

import { PaymentInfo } from '../../../interfaces/paymentResult';
import { PaymentResultQueryParamsKeys } from '../../../constants/pathQueryParams';
import {
  SCAN_IQ_PAYMENT_RESULT_TYPE,
  ScanIqPaymentResultType,
} from '../../../constants/scanIqPaymentResultType';
import { getPaymentResultParams } from '../../../utils/getPaymentResultParams';
import { paymentResultService } from '../../../services/paymentResultService';

type UseScanIqPaymentResultReturn = {
  paymentInfo: PaymentInfo | null;
  params: Record<PaymentResultQueryParamsKeys, any>;
  paymentResultType: ScanIqPaymentResultType;
  isSuccess: boolean;
};

export const useScanIqPaymentResult = (): UseScanIqPaymentResultReturn => {
  const [paymentInfo, setPaymentInfo] = useState<PaymentInfo | null>(null);

  const params = getPaymentResultParams();
  const { paymentIntentId, connectedAccountId, paymentResultType, redirectStatus } =
    params;

  const isSuccess = redirectStatus === 'succeeded';

  const getPaymentInfo = async () => {
    if (!paymentIntentId || !connectedAccountId) {
      console.error('Not all required data is set');
    } else {
      //TODO: use request specific for ScanIQ when backend will provide it
      const result = await paymentResultService.getPaymentDetails(
        paymentIntentId,
        connectedAccountId,
      );

      setPaymentInfo(result);
    }
  };

  useEffect(() => {
    if (paymentResultType === SCAN_IQ_PAYMENT_RESULT_TYPE.WITH_PAYMENT) {
      getPaymentInfo();
    }
  }, [paymentResultType]);

  return {
    paymentInfo,
    params,
    paymentResultType,
    isSuccess,
  };
};
